module.exports = __webpack_public_path__ + "img/payment_and_qr_code.de870e0f.png";